<div class="row mx-0 all-questions" id="allquestion">
  <div class="col-12 px-0 border-btm ">
    <div class="pointer-cursor position-absolute right-align z-999">
      <img src="assets/images/close-movie.svg" alt="" (click)="close()" height="24" width="24">
    </div>
    <p class="mulish-800 text-16">{{'Sustainable development goals' | translate}}</p>
  </div>
  <div class="col-12 px-0">
    <p class="text-14 mulish-normal pt-3 text-left">
      {{'Building on the principle of “leaving no one behind”, the new agenda emphasizes a holistic approach to achieving sustainable development for all. Here are the 17 goals to transform our world.' | translate}}
    </p>

  </div>
  <div class="col-12 px-0">
    <div class="row mx-0 scroll">
      <div class="col-4 px-0 mt-3 pr-3" *ngFor="let question of data ; let i = index;let odd=odd;">
        <div class="question-card d-flex flex-column justify-content-between h-100">
          <div class="d-flex align-items-center">
            <img *ngIf="question.image != null" [src]="question.image" alt="" class="img-circle" width="28" height="28">
            <img *ngIf="question.image == null" src="assets/images/no-poverty.png" alt="" class="img-circle" width="28"
              height="28">
            <p class="mulish-bold text-xxs text-left d-flex align-items-center pl-3 mb-0 text-break">{{question.name}}
            </p>
          </div>
          <div class="d-flex mt-3">
            <img class="badge-img" *ngIf="question.info.badge == 'None'" src="assets/images/no-badge.svg" alt=""
              width="48" height="48">
            <img class="badge-img" *ngIf="question.info.badge == 'Bronze'" src="assets/images/bronze-badge.svg" alt=""
              width="48" height="48">
            <img class="badge-img" *ngIf="question.info.badge == 'Silver'" src="assets/images/silver-badge.svg" alt=""
              width="48" height="48">
            <img class="badge-img" *ngIf="question.info.badge == 'Gold'" src="assets/images/gold-badge.svg" alt=""
              width="48" height="48">
            <div class="pl-3">
              <p *ngIf="question.info.badge == 'None'" class="mulish-normal text-xxxs color-5F5F5F">
                {{'No badge yet' | translate}}</p>
              <p *ngIf="question.info.badge != 'None'" class="mulish-normal text-xxxs color-5F5F5F">
                {{question.info.badge | translate}}</p>
              <div class="score-chip mulish-bold text-xxs pl-3">
                {{'Score :' | translate}} {{question.info.score}}/{{question.info.maximum_score}}
              </div>
            </div>

          </div>
          <div class="d-flex mt-3">
            <div class="">
              <div class="mulish-normal text-xxs mb-2">
                {{'Questions completed :' | translate}} {{question.info.answered_questions}} /
                {{question.info.total_questions}}
              </div>
              <div class="custom-progress">
                <div class="progress">
                  <div class="progress-bar bg-primary" role="progressbar"
                    [style.width.%]="question?.info.attempted_percentage" aria-valuenow="12" aria-valuemin="0"
                    aria-valuemax="100"></div>
                </div>
              </div>

            </div>
            <div class="pl-3">
              <div *ngIf="question.info.answered_questions == question.info.total_questions"
                class="py-2 px-3 flex-center badge-custom cursor-pointer mulish-bold btn-light btn-block mb-3"
                (click)="viewQuestion(question)">
                <div> {{'View' | translate | uppercase}} </div>
                <mat-icon class="ml-3">arrow_right_alt</mat-icon>
              </div>
              <div *ngIf="question.info.answered_questions != question.info.total_questions"
                class="py-2 px-3 flex-center badge-custom cursor-pointer mulish-bold btn-light btn-block mb-3"
                (click)="viewQuestion(question)">
                <div> {{'Start' | translate | uppercase}} </div>
                <mat-icon class="ml-3">arrow_right_alt</mat-icon>
              </div>
            </div>

          </div>

        </div>
      </div>

    </div>

  </div>
